import { AuthConfig } from 'angular-oauth2-oidc';
import { LogLevels, InstanceTypes } from 'ng-shared-library';

export const errorInterceptorSkipHeader = 'X-Skip-Error-Interceptor';
export const loadingInterceptorSkipHeader = 'X-Skip-Loading-Interceptor';
export const loginRedirectSkipHeader = 'X-Skip-Login-Redirect';

export const environment = {
  production: false,
  apiUrlRoot: '/api_staging',
  authUrl: 'https://mirror-accounts.connectpayusa.com/api',
  defaultTaskDueTime: '15:00', // hh:mm
  watermarkText: 'RELAY PROD MIRROR',
  logLevel: LogLevels.Debug,
  // 6208: per Paula and Richard, use 50 min so we check for idle before the 60min timeout
  // prior to the auth cookie itself hitting its expiration limit  --nk 2020-07-28
  idleLimitSeconds: 3000,
  idleReloginGraceSeconds: 180,
  GoogleTrackingId: 'G-0QCY4QV6PP',
  EnableUserManagement: true,
  instanceType: InstanceTypes.CsrPortal,
  defaultOfficeGroup: 'DEFAULT_OFFICE_GROUP',
  siteUrlRoot: 'https://olympus.connectpayusa.com/apollo_staging',
  landingPortalUrl: 'https://olympus.connectpayusa.com/login_staging',
  opsPortalUrl: 'https://olympus.connectpayusa.com/apollo_staging',
  endOfDayCutoff: {
    hours: 17,
    minutes: 0
  },
  allowedRoles: ['CSR1', 'CSR', 'Banking', 'Corporate_Reports', 'Supervisor'],
  permissionRoles: ['CSR1', 'CSR', 'Banking', 'Corporate_Reports', 'Supervisor'],
  taxObligationThreshold: 100000
};

export const authCodeFlowConfig: AuthConfig = {
  issuer: 'https://mirror-accounts.connectpayusa.com',
  clientId: '7fff9298-6aaa-75c6-cf72-ccd0f97c81c0_relay.portal',
  redirectUri: 'https://olympus.connectpayusa.com/apollo_staging/authenticate',
  postLogoutRedirectUri: 'https://olympus.connectpayusa.com/apollo_staging/',
  logoutUrl: 'https://mirror-accounts.connectpayusa.com/connect/endsession',
  responseType: 'code',
  scope: 'openid roles userprofile cp.relay.api.csr cp.identity.api.general',
  showDebugInformation: true,
  disablePKCE: true,
  customQueryParams: { prompt: 'login' }
};
